import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {DialogSaveButton} from '../../../common/Global/globalStyles.style';
import {isEmptyVariable, isEmptyArray, getLocalStorageVariables, handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import RegularDropdown from '../../../common/DropdownMenus/RegularDropdown';
import MultiSelectFunctionDialog from "../../Masters/DocumentMaster/functionMultiSelect";

let userDetails = getLocalStorageVariables();

const functionPlaceholder = "Select Function";
const departmentDropdownDefaultValue = "Select Department";
const defaultDocTypePlaceholder = "Select Document Type";

class AddDocument extends Component{
    
    constructor(props){
        super(props);
        this.state = {
            name:"",
            shortName:"",
            description:"",
            checkedFunctionName:functionPlaceholder,
            checkedFunctionIds:[],
            selectedDocType:defaultDocTypePlaceholder,
            selectedDocumentId:"",
            selectedDocumentName:departmentDropdownDefaultValue,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
            formErrors:{},
            docTypes:[],
            selectedDepartmentId:"",
            selectedDepartmentName:"",
            showMultiSelectFunctionTreeDialog:false
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showCreateDialog){

            if(this.props.isEdit){
                let selectedItem = this.props.selectedItem;
                //first get the list of functionIds
                let selectedFunctionArr =  [];
                let functionListArr = [];
                if(!isEmptyVariable(selectedItem.functionList)){
                    functionListArr = selectedItem.functionList.split(";;");
                }
                functionListArr.forEach(item=>{
                    selectedFunctionArr.push(item.split(":-:")[1])
                })
                let functionName = "";
                if(functionListArr.length === 1){
                    functionName = "1 Function Selected";
                }else{
                    functionName = selectedFunctionArr.length+" Functions Selected"
                }
                this.setState({
                    name:selectedItem.name_new,
                    shortName:selectedItem.shortName_new,
                    checkedFunctionName:functionName,
                    checkedFunctionIds:selectedFunctionArr,
                    selectedDocType:selectedItem.documentType_new,
                    description:selectedItem.description_new,
                    docTypes:this.props.docTypes,
                    selectedDepartmentName:"",
                    selectedDepartmentId:selectedItem.departmentId,
                    submitClickedAtleastOnce:false,
                    formErrors:{},
                })
            }else{
                let departmentArr = this.props.departmentArr;
                let selectedDepartmentId = "";
                let selectedDepartmentName = departmentDropdownDefaultValue;
    
                if(!isEmptyArray(departmentArr) && departmentArr.length === 1){
                    selectedDepartmentId = departmentArr[0].departmentId;
                    selectedDepartmentName = departmentArr[0].name;
                }
                if(!isEmptyArray(departmentArr) && departmentArr.length > 1){
                    selectedDepartmentId="";
                    selectedDepartmentName=departmentDropdownDefaultValue;
                }
    
                this.setState({  
                    name:"",
                    shortName:"",
                    description:"",
                    docTypes:this.props.docTypes,
                    checkedFunctionName:functionPlaceholder,
                    checkedFunctionIds:[],
                    selectedDocType:defaultDocTypePlaceholder,
                    selectedDepartmentId:selectedDepartmentId,
                    selectedDepartmentName:selectedDepartmentName,
                    submitClickedAtleastOnce:false,
                    formErrors:{}
                })
            }
        }
    }

    deptDropdownClick = (item) => {
        let FormErrorsTemp  = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['deparment'] = "";
        }

        this.setState({
            selectedDepartmentName:item.name,
            selectedDepartmentId:item.departmentId,
            formErrors:FormErrorsTemp
        })
    }

    docTypeDropdownClick = (item) => {
        let FormErrorsTemp  = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['docType'] = "";
        }

        this.setState({
            selectedDocType:item.documentType,
            formErrors:FormErrorsTemp
        })
    }

    handleChange = (e) => {
        const { name, value } = e.target;

        let FormErrorsTemp = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            if(name === "shortName"){
                if(isEmptyVariable(value)){
                    FormErrorsTemp['shortName'] = "Please enter master short name";
                }else{
                    FormErrorsTemp['shortName'] = "";
                }
            }else if(name === "name"){
                if(isEmptyVariable(value)){
                    FormErrorsTemp['name'] = "Please enter master name";
                }else{
                    FormErrorsTemp['name'] = "";
                }
            }else if(name === "description"){
                if(!isEmptyVariable(value) && value.length > Constants.DESC_STRING_LENGTH){
                    FormErrorsTemp['description'] = "Description must be less then 500 characters";
                }else{
                    FormErrorsTemp['description'] = "";
                }
            }
        }

        this.setState({ 
            [name]: value ,
            formErrors:FormErrorsTemp
        });
    }
    
    handleMultiSelectFuncDialogShow = () => {
        let formErrors = this.state.formErrors;
        
        if(isEmptyVariable(this.state.selectedDepartmentId)){
            formErrors["checkedFunctionName"] = "Please select the department"
            this.setState({
                formErrors:formErrors
            })
        }else{
            formErrors["checkedFunctionName"] = ""
            this.setState({
                formErrors:formErrors,
                showMultiSelectFunctionTreeDialog:true,
            })
        }
    }

    onKeyBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.handleMultiSelectFuncDialogShow();
        }
    }
        
    handleMultiSelectFunctionTreeDialogClose = () => {
        this.setState({
            showMultiSelectFunctionTreeDialog:false,
        })
    }

    handleMultiSelectSubmit = (selectedFunctionIds,selectedFunctionName) => {
        this.setState({
            showMultiSelectFunctionTreeDialog:false,
            checkedFunctionIds:selectedFunctionIds,
            checkedFunctionName:selectedFunctionName
        })
    }
    /*******************API CALLS*******************/

    handleCreateMaster = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};

        if(isEmptyVariable(this.state.selectedDocType) ||
        this.state.selectedDocType===defaultDocTypePlaceholder){
            isError = true;
            FormErrorsTemp['docType'] = "Please select document type";
        }

        if(isEmptyVariable(this.state.name)){
            isError = true;
            FormErrorsTemp['name'] = "Please enter master name";
        }

        if(isEmptyVariable(this.state.shortName)){
            isError = true;
            FormErrorsTemp['shortName'] = "Please enter master short name";
        }

        if(isEmptyArray(this.state.checkedFunctionIds)){
            isError = true;
            FormErrorsTemp['checkedFunctionName'] = "Please select atleast one function";
        }

        if(!isEmptyVariable(this.state.description)){
            if(this.state.description.length > Constants.DESC_STRING_LENGTH){
                isError = true;
                FormErrorsTemp['description'] = "Description must be less then 500 characters";
            }
        }

        if(!this.props.isEdit){
            if(isEmptyVariable(this.state.selectedDepartmentName) || 
            this.state.selectedDepartmentName === departmentDropdownDefaultValue){
                isError = true;
                FormErrorsTemp['deparment'] = "Please select the department";
            }
        }
        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });

        }else{
            let url = "";

            if(this.props.isEdit){
                url = Constants.EditDocumentMaster;
            }else{
                url = Constants.CreateDocumentMaster;
            }

            fetch(url,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    shortName:this.state.shortName,
                    name:this.state.name,
                    description:this.state.description,
                    departmentId:this.state.selectedDepartmentId,
                    functionIds:JSON.stringify(this.state.checkedFunctionIds),
                    documentId:this.props.selectedId,
                    documentType:this.state.selectedDocType,
                    sourcePage:this.props.sourcePage
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        showCreateDialog:false,
                        showLoader:false,
                        isEdit:false,
                        selectedId:"",
                        name:"",
                        shortName:"",
                        description:"",
                        checkedFunctionIds:[],
                        selectedDocType:defaultDocTypePlaceholder,
                    },() => {
                        this.props.handleCreateDialogClose(true);
                    });
                }else{
                    this.setState({
                        showLoader:false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    });
                }
            });
        }
    }
    /*******************API CALLS END HERE*******************/

    render(){
        return(
            <section>
            <Modal className="custom-dialog" show={this.props.showCreateDialog} backdrop="static">
                <Modal.Header>
                    <h5>{this.props.isEdit?"Edit Document":"Add Document"}</h5>
                    <button 
                        onClick={this.props.handleCreateDialogClose}
                        type="button" data-dismiss="modal">
                        <span class="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div class="modal-body">
                    <div class="addnew-modal-form">
                        {
                            !this.props.isEdit &&
                            !isEmptyArray(this.props.departmentArr) &&
                            this.props.departmentArr.length > 1 &&
                            <div class="addnew-modal-form-group">
                                <p>Department*</p>
                                <RegularDropdown
                                    placeholder={this.state.selectedDepartmentName}
                                    dropdownArr={this.props.departmentArr}
                                    labelParam="name"
                                    onDropDownItemClick={this.deptDropdownClick}
                                    defaultPlaceholderDropDown={departmentDropdownDefaultValue}
                                />
                                {
                                    !isEmptyVariable(this.state.formErrors['deparment']) &&
                                    <span class="cm-error">{this.state.formErrors['deparment']}</span>
                                }
                            </div>
                        }
                        <div class="addnew-modal-form-group">
                            <p>Document Type*</p>
                            <RegularDropdown 
                                placeholder={this.state.selectedDocType}
                                dropdownArr={this.state.docTypes}
                                labelParam="documentType"
                                onDropDownItemClick={this.docTypeDropdownClick}
                                defaultPlaceholderDropDown = {defaultDocTypePlaceholder}
                                
                            />
                            {
                                !isEmptyVariable(this.state.formErrors['docType']) &&
                                <span class="cm-error">{this.state.formErrors['docType']}</span>
                            }
                        </div>
                        <div class="addnew-modal-form-group">
                            <p>Short Name*</p>
                            <input type="text" placeholder="Enter Short Name"
                            name="shortName" value={this.state.shortName} onChange={this.handleChange}/>
                            {
                                !isEmptyVariable(this.state.formErrors['shortName']) &&
                                <span class="cm-error">{this.state.formErrors['shortName']}</span>
                            }
                        </div>
                        <div class="addnew-modal-form-group">
                            <p>Name*</p>
                            <input type="text" placeholder="Enter Name" spellCheck="true"  
                            name="name" value={this.state.name} onChange={this.handleChange}/>
                            {
                                !isEmptyVariable(this.state.formErrors['name']) &&
                                <span class="cm-error">{this.state.formErrors['name']}</span>
                            }
                        </div>
                        <div className="addnew-modal-form-group">
                            <p>Functions*</p>
                            <div className="dummy-dropdown" tabIndex={0} onKeyPress={this.onKeyBtnPress}  
                            onClick={this.handleMultiSelectFuncDialogShow}>
                                <p class="placeholder-text">{this.state.checkedFunctionName}</p>
                                <span class="material-icons">keyboard_arrow_right</span>
                            </div>
                            {
                                !isEmptyVariable(this.state.formErrors['checkedFunctionName']) &&
                                <span className="cm-error">{this.state.formErrors['checkedFunctionName']}</span>
                            }
                        </div>
                        <div class="addnew-modal-form-group">
                            <p>Description</p>
                            <textarea type="text" placeholder="Enter Description" spellCheck="true" 
                            name="description" value={this.state.description} onChange={this.handleChange}/>
                            {
                                !isEmptyVariable(this.state.formErrors['description']) &&
                                <span class="cm-error">{this.state.formErrors['description']}</span>
                            }
                            {/* {
                                !isEmptyVariable(this.state.formErrors['apiErr']) &&
                                <span class="cm-error">{this.state.formErrors['apiErr']}</span>
                            } */}
                        </div>
                    </div>
                    <div class="modal-close-save">
                        <div class="close-save-col">
                            <button onClick={this.props.handleCreateDialogClose} type="button" class="modal-close">Cancel</button>
                            <DialogSaveButton themeSettings={this.props.themeSettings}  onClick={this.handleCreateMaster} type="button">Save</DialogSaveButton>
                        </div>
                    </div>
                </div>
            </Modal>
            <MultiSelectFunctionDialog
                showFunctionsDialog={this.state.showMultiSelectFunctionTreeDialog}
                selectedFunctionIdsArr={this.state.checkedFunctionIds}
                handleSelectFuncDialogClose={this.handleMultiSelectFunctionTreeDialogClose}
                handleSelectFunctionDialogSaveClose={this.handleMultiSelectSubmit}
                themeSettings={this.props.themeSettings}
                departmentId={this.state.selectedDepartmentId}
            />
            </section>
        )
    }
}

export default AddDocument;